import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-304dd8ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-wrapper" }
const _hoisted_2 = { class: "filter-select-wrapper" }
const _hoisted_3 = ["textContent", "selected"]
const _hoisted_4 = ["textContent", "selected", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        class: "filter-select fw6",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onChange && $setup.onChange(...args)))
      }, [
        _createElementVNode("option", {
          textContent: _toDisplayString($props.title),
          disabled: "",
          selected: $props.selected === -1
        }, null, 8, _hoisted_3),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            textContent: _toDisplayString(option),
            selected: i === $props.selected,
            value: option
          }, null, 8, _hoisted_4))
        }), 128))
      ], 32)
    ])
  ]))
}